"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const StepIcon_1 = __importDefault(require("../StepIcon"));
const common_components_1 = require("@zapier/common-components");
const design_system_1 = require("@zapier/design-system");
const theme_1 = require("../../theme");
const common_utils_1 = require("@zapier/common-utils");
const StepCardEditButton_1 = __importDefault(require("./StepCardEditButton"));
const StepMenu_1 = __importDefault(require("../StepMenu"));
const StepMenuButton_1 = __importDefault(require("../StepMenuButton"));
const StepTitleSection_1 = __importDefault(require("./StepTitleSection"));
const stepCardHeaderCss = {
    display: 'flex',
    padding: 18,
};
const headingCss = {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    overflow: 'hidden',
    width: '100%',
};
const secondaryActionsCss = {
    alignItems: 'center',
    display: 'flex',
    marginLeft: 'auto',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    width: '10%',
    [theme_1.Media.Desktop]: {
        display: 'flex',
    },
};
const StepCardHeader = ({ api, defaultTitle, hasEditAction, hasRename, hasSecondaryActions, isZapTemplate, label, onClickGuideButton, onCommitStepTitle, onDelete, pathInfo, stepNumber, stepStatus, subtitle, title, }) => {
    const [isEditingStepTitle, setIsEditingStepTitle] = react_1.useState(false);
    const onDeleteWrapper = () => {
        if (onDelete) {
            onDelete();
        }
    };
    const onRename = () => {
        setIsEditingStepTitle(true);
    };
    const onCommitStepTitleWrapper = react_1.useCallback((newTitle) => {
        setIsEditingStepTitle(false);
        if (title || newTitle !== defaultTitle) {
            onCommitStepTitle(newTitle);
        }
    }, [defaultTitle, onCommitStepTitle, title]);
    return (common_utils_1.isolateComponent("div", { css: stepCardHeaderCss },
        common_utils_1.isolateComponent(StepIcon_1.default, { api: api, pathInfo: pathInfo, status: stepStatus }),
        common_utils_1.isolateComponent(design_system_1.Heading, { css: headingCss },
            common_utils_1.isolateComponent(StepTitleSection_1.default, { defaultTitle: defaultTitle, isEditingStepTitle: isEditingStepTitle, isZapTemplate: isZapTemplate, label: label, onCommitStepTitle: onCommitStepTitleWrapper, stepNumber: stepNumber, subtitle: subtitle, title: title }),
            hasEditAction && common_utils_1.isolateComponent(StepCardEditButton_1.default, null)),
        hasSecondaryActions && (common_utils_1.isolateComponent("div", { css: secondaryActionsCss },
            common_utils_1.isolateComponent(common_components_1.ClickPropagationBarrier, null,
                onClickGuideButton && (common_utils_1.isolateComponent(StepMenuButton_1.default, { ariaLabel: "Step guide", iconName: "question", onClick: onClickGuideButton })),
                common_utils_1.isolateComponent(StepMenu_1.default, { hasDelete: !!onDelete, hasRename: hasRename, onDelete: onDeleteWrapper, onRename: onRename }))))));
};
const FastStepCardHeader = react_1.memo(StepCardHeader);
exports.default = FastStepCardHeader;
